import { Reducer } from "redux";

import {
	VendorOpportunityActions,
	VendorOpportunityActionTypes
} from "../../../actions/Vendor/Opportunity";

export interface VendorOpportunityState {
	readonly isLoading: boolean;
	readonly addOpportunityDrawerVisible: boolean;
	readonly editOpportunityDrawerVisible: boolean;
}

export const initialVendorOpportunityState: VendorOpportunityState = {
	isLoading: false,
	addOpportunityDrawerVisible: false,
	editOpportunityDrawerVisible: false
};

export const VendorOpportunityReducer: Reducer<
	VendorOpportunityState,
	VendorOpportunityActions
> = (
	state: VendorOpportunityState = initialVendorOpportunityState,
	action: VendorOpportunityActions
): VendorOpportunityState => {
	switch (action.type) {
		case VendorOpportunityActionTypes.SHOW_VENDOR_OPPORTUNITY_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case VendorOpportunityActionTypes.HIDE_VENDOR_OPPORTUNITY_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case VendorOpportunityActionTypes.OPEN_ADD_OPPORTUNITY_DRAWER:
			return {
				...state,
				addOpportunityDrawerVisible: true
			};
		case VendorOpportunityActionTypes.CLOSE_ADD_OPPORTUNITY_DRAWER:
			return {
				...state,
				addOpportunityDrawerVisible: false
			};
		case VendorOpportunityActionTypes.OPEN_EDIT_OPPORTUNITY_DRAWER:
			return {
				...state,
				editOpportunityDrawerVisible: true
			};
		case VendorOpportunityActionTypes.CLOSE_EDIT_OPPORTUNITY_DRAWER:
			return {
				...state,
				editOpportunityDrawerVisible: false
			};
		default: {
			return state;
		}
	}
};

export default VendorOpportunityReducer;
